import app from 'flarum/forum/app';
import Modal from 'flarum/components/Modal';
import Button from 'flarum/components/Button';

import Stream from 'flarum/utils/Stream';
import withAttr from 'flarum/utils/withAttr';
import ItemList from 'flarum/common/utils/ItemList';
import { getPermanentSuspensionDate } from '../helpers/suspensionHelper';
import AlertUtil from 'flarum/forum/dianLiang/AlertUtil';

export default class SuspendUserModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);

    let until = this.attrs.user.suspendedUntil();
    const reason = this.attrs.user.suspendReason();
    const message = this.attrs.user.suspendMessage();
    let status = null;

    if (new Date() > until) until = null;

    if (until) {
      if (until.getFullYear() === 9999) status = 'indefinitely';
      else status = 'limited';
    }

    this.status = Stream(status);
    this.reason = Stream(reason);
    this.message = Stream(message);
    // this.daysRemaining = Stream(status === 'limited' && -dayjs().diff(until, 'days') + 1);
    this.days = Stream(0);
    this.hours = Stream(0);
    this.minutes = Stream(0);
    if (status === 'limited') {
      const now = dayjs(); // 当前时间
      const diffInMinutes = -now.diff(until, 'minutes'); // 计算当前时间与目标日期之间的分钟差异
      this.days = Stream(Math.floor(diffInMinutes / (24 * 60))); // 计算天数部分
      this.hours = Stream(Math.floor((diffInMinutes % (24 * 60)) / 60)); // 计算小时部分
      this.minutes = Stream(diffInMinutes % 60); // 计算分钟部分
    }
  }

  className() {
    return 'SuspendUserModal Modal--medium';
  }

  title() {
    return app.translator.trans('flarum-suspend.forum.suspend_user.title', { user: this.attrs.user });
  }

  content() {
    return (
      <div className="Modal-body">
        <div className="Form">
          <div className="Form-group">
            <label>{app.translator.trans('flarum-suspend.forum.suspend_user.status_heading')}</label>
            <div>{this.formItems().toArray()}</div>
          </div>

          <div className="Form-group">
            <Button className="Button Button--primary" loading={this.loading} type="submit">
              {app.translator.trans('flarum-suspend.forum.suspend_user.submit_button')}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  radioItems() {
    const items = new ItemList();

    items.add(
      'not-suspended',
      <label className="checkbox">
        <input type="radio" name="status" checked={!this.status()} value="" onclick={withAttr('value', this.status)} />
        {app.translator.trans('flarum-suspend.forum.suspend_user.not_suspended_label')}
      </label>,
      100
    );

    items.add(
      'indefinitely',
      <label className="checkbox">
        <input type="radio" name="status" checked={this.status() === 'indefinitely'} value="indefinitely" onclick={withAttr('value', this.status)} />
        {app.translator.trans('flarum-suspend.forum.suspend_user.indefinitely_label')}
      </label>,
      90
    );

    items.add(
      'time-suspension',
      <label className="checkbox SuspendUserModal-days">
        <input
          type="radio"
          name="status"
          checked={this.status() === 'limited'}
          value="limited"
          onclick={(e) => {
            this.status(e.target.value);
            m.redraw.sync();
            this.$('.SuspendUserModal-days-input input').select();
            e.redraw = false;
          }}
        />
        {app.translator.trans('flarum-suspend.forum.suspend_user.limited_time_label')}
        {this.status() === 'limited' && (
          <div className="SuspendUserModal-days-input">
            <input type="number" min="0" value={this.days()} oninput={withAttr('value', this.days)} className="FormControl" />
            {app.translator.trans('flarum-suspend.forum.suspend_user.limited_time_days_text')}
            <input type="number" min="0" max="60" value={this.hours()} oninput={withAttr('value', this.hours)} className="FormControl" />
            {app.translator.trans('dl-index.forum.suspendModal.limit_hour')}
            <input type="number" min="0" max="60" value={this.minutes()} oninput={withAttr('value', this.minutes)} className="FormControl" />
            {app.translator.trans('dl-index.forum.suspendModal.limit_minute')}
          </div>
        )}
      </label>,
      80
    );

    return items;
  }

  formItems() {
    const items = new ItemList();

    items.add('radioItems', <div className="Form-group">{this.radioItems().toArray()}</div>, 100);

    // items.add(
    //   'reason',
    //   <div className="Form-group">
    //     <label>
    //       {app.translator.trans('flarum-suspend.forum.suspend_user.reason')}
    //       <textarea
    //         className="FormControl"
    //         bidi={this.reason}
    //         placeholder={app.translator.trans('flarum-suspend.forum.suspend_user.placeholder_optional')}
    //         rows="2"
    //       />
    //     </label>
    //   </div>,
    //   90
    // );

    items.add(
      'message',
      <div className="Form-group">
        <label>
          {app.translator.trans('flarum-suspend.forum.suspend_user.display_message')}
          <div className="textarea-box">
            <textarea
              className="FormControl"
              maxlength="1000"
              bidi={this.message}
              // placeholder={app.translator.trans('flarum-suspend.forum.suspend_user.placeholder_optional')}
              rows="2"
            />
            <span className="charCount">{this.message() ? this.message().length : 0} / 1000</span>
          </div>
        </label>
      </div>,
      80
    );

    return items;
  }

  onsubmit(e) {
    e.preventDefault();

    this.loading = true;

    let suspendedUntil = null;
    let alertText = app.translator.trans('dl-index.forum.permissions.success_label');
    switch (this.status()) {
      case 'indefinitely':
        suspendedUntil = getPermanentSuspensionDate();
        if (!this.message()) {
          this.loading = false;
          alertText = app.translator.trans('dl-index.forum.suspendModal.suspend_reson_is_null');
          AlertUtil.onWarn(app, alertText);
          return;
        }
        break;

      case 'limited':
        suspendedUntil = dayjs().add(this.days(), 'days').add(this.hours(), 'hours').add(this.minutes(), 'minutes').toDate();
        if ((!this.days() && !this.hours() && !this.minutes()) || !this.message()) {
          this.loading = false;
          alertText = app.translator.trans('dl-index.forum.suspendModal.suspend_time_or_reson_is_null');
          AlertUtil.onWarn(app, alertText);
          return;
        }
        break;

      default:
      // no default
    }

    this.attrs.user.save({ suspendedUntil, suspendReason: this.reason(), suspendMessage: this.message() }).then(() => {
      AlertUtil.onSuccess(app, alertText);
      this.hide();
      this.loaded.bind(this);
    });
  }
}
